var _defs, _path, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "335.05 391 340.23 289.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        font-size: 24px;\n      }\n\n      .st0, .st1 {\n        font-family: Constantia, Constantia;\n      }\n\n      .st1 {\n        font-size: 36px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M605.01,391.01s-.02-.01-.03-.01h-189.09c-.92,0-1.75.37-2.36.98-.65.65-1.03,1.57-.97,2.58.11,1.79,1.74,3.11,3.53,3.11h185.59s.02,0,.03.01l73.56,86.43s.01.04,0,.05l-165.68,186.27s-.04.02-.06,0l-165.68-186.27s-.01-.04,0-.05l58.67-68.93s.02-.01.03-.01h191.05s.02,0,.03.01l58.45,68.68s.01.04,0,.05l-142.48,160.2s-.04.02-.06,0l-142.48-160.2s-.01-.04,0-.05l43.56-51.18s.02-.01.03-.01h174.87s.02,0,.03.01l43.35,50.93s.01.04,0,.05l-119.29,134.12s-.04.02-.06,0l-118.7-133.45s-.02-.01-.03-.01c-1.9.13-3.8.3-5.71.43h0c-.49.17-1,.33-1.54.46-.25.06-.51.09-.76.1l126.75,142.51s.04.02.06,0l128.13-144.05s.01-.04,0-.05l-49.1-57.69s-.02-.01-.03-.01h-181.04s-.02,0-.03.01l-49.31,57.94s-.01.04,0,.05l151.32,170.13s.04.02.06,0l151.33-170.13s.01-.04,0-.05l-64.21-75.44s-.02-.01-.03-.01h-197.21s-.02,0-.03.01l-64.42,75.7s-.01.04,0,.05l174.52,196.21s.04.02.06,0l93.28-104.87c46.61-52.4,47.52-131.12,2.14-184.59h0Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(453 537.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Be brilliant"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(427.79 494.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "StayAhead"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe8d951bdf4d8361e4351df1419915ad.svg";
export { ForwardRef as ReactComponent };